/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  X,
  Check,
  RefreshCw,
  Lock,
  Info,
  ShoppingBag,
  ExternalLink,
  Box,
  Tag,
} from "lucide-react";
import { useTranslation } from "react-i18next";

export default function FacebookCatalogIntegration({ close }) {
  const { t } = useTranslation();
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const valid =
    account?.testAppCatalog || account?.subscription?.plan === "الأسطورية";
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    facebookPixelId: "",
    facebookAccessToken: "",
    catalogId: "",
    businessManagerId: "",
  });

  useEffect(() => {
    if (store) {
      setData({
        facebookCatalogUsername: store?.facebookCatalogFeed?.username || "",
        facebookCatalogPassword: store?.facebookCatalogFeed?.password || "",
      });
    }
  }, [store]);

  const showAlert = (
    icon,
    title,
    text,
    confirmButtonText = t("servicePageActivation.confirmChat.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      confirmButtonColor: "rgb(66, 103, 178)", // Bleu Facebook
      allowOutsideClick: false,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data.facebookCatalogUsername || !data.facebookCatalogPassword) {
      await showAlert(
        "warning",
        t("servicePageActivation.facebookCatalogue.actions.missingDataTitle"),
        t(
          "servicePageActivation.facebookCatalogue.actions.missingDataDescription"
        )
      );
      return;
    }

    try {
      setLoading(true);

      const updatedStore = {
        ...store,
        facebookCatalogFeed: {
          username: data.facebookCatalogUsername,
          password: data.facebookCatalogPassword,
        },
      };

      await saveStoreDraft(doc(db, "store", store.id), store, updatedStore);
      dispatch(applyStoreDraft(store, updatedStore));

      setLoading(false);
      await showAlert(
        "success",
        t("servicePageActivation.facebookCatalogue.actions.successSaveTitle"),
        t(
          "servicePageActivation.facebookCatalogue.actions.successSaveDescription"
        )
      );
      close();
    } catch (error) {
      setLoading(false);
      await showAlert(
        "error",
        t("servicePageActivation.facebookCatalogue.actions.errorSaveTitle"),
        t(
          "servicePageActivation.facebookCatalogue.actions.errorSaveDescription"
        )
      );
      console.error("Error saving Facebook catalog settings:", error);
    }
  };

  const handleDisable = async () => {
    const result = await Swal.fire({
      title: t("servicePageActivation.facebookCatalogue.actions.disableTitle"),
      text: t("servicePageActivation.facebookCatalogue.actions.disableText"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t(
        "servicePageActivation.facebookCatalogue.actions.disableConfirmText"
      ),
      cancelButtonText: t(
        "servicePageActivation.facebookCatalogue.actions.disableCancelText"
      ),
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);

        const updatedStore = {
          ...store,
          facebookCatalogFeed: {
            username: "",
            password: "",
          },
        };

        await saveStoreDraft(doc(db, "store", store.id), store, updatedStore);
        dispatch(applyStoreDraft(store, updatedStore));

        setData({
          facebookCatalogUsername: "",
          facebookCatalogPassword: "",
        });

        setLoading(false);
        await showAlert(
          "success",
          t(
            "servicePageActivation.facebookCatalogue.actions.disableSuccessTitle"
          ),
          t(
            "servicePageActivation.facebookCatalogue.actions.disableSuccessDescription"
          )
        );
      } catch (error) {
        setLoading(false);
        await showAlert(
          "error",
          t(
            "servicePageActivation.facebookCatalogue.actions.disableErrorTitle"
          ),
          t(
            "servicePageActivation.facebookCatalogue.actions.disableErrorDescription"
          )
        );
        console.error("Error disabling Facebook catalog:", error);
      }
    }
  };

  const facebookBenefits = [
    {
      title: t("servicePageActivation.facebookCatalogue.benefits.0.title"), // مزامنة المنتجات
      description: t(
        "servicePageActivation.facebookCatalogue.benefits.0.description"
      ), // مزامنة تلقائية لمنتجاتك مع كتالوج فيسبوك
      icon: <ShoppingBag className="text-[#9e68ba]" size={20} />,
    },
    {
      title: t("servicePageActivation.facebookCatalogue.benefits.1.title"), // إعلانات ديناميكية
      description: t(
        "servicePageActivation.facebookCatalogue.benefits.1.description"
      ), // إنشاء إعلانات ديناميكية تعرض المنتجات المناسبة
      icon: <Tag className="text-[#9e68ba]" size={20} />,
    },
    {
      title: t("servicePageActivation.facebookCatalogue.benefits.2.title"), // تتبع التحويلات
      description: t(
        "servicePageActivation.facebookCatalogue.benefits.2.description"
      ), // قياس فعالية حملاتك الإعلانية بدقة
      icon: <Box className="text-[#9e68ba]" size={20} />,
    },
  ];

  return valid ? (
    <div className="min-h-[400px] h-fit p-6">
      <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!bg-[#181919] dark:!border-[#3c3a3d]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] dark:text-[#b47ed6] mb-2 flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              width="24px"
              height="24px"
              className="ml-2"
            >
              <path
                fill="#1877F2"
                d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
              />
              <path
                fill="#FFF"
                d="M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"
              />
            </svg>
            {t("servicePageActivation.facebookCatalogue.title")}
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            {t("servicePageActivation.facebookCatalogue.description")}
          </p>

          <div className="bg-blue-50 dark:!bg-blue-900/20 rounded-lg border border-blue-200 dark:!border-blue-700 p-4 flex mb-6">
            <Info
              size={20}
              className="text-blue-500 dark:text-blue-300 ml-2 flex-shrink-0 mt-1"
            />
            <div>
              <p className="font-medium text-blue-800 dark:text-blue-300 mb-1">
                {t("servicePageActivation.facebookCatalogue.infoBox.title")}
              </p>
              <p className="text-blue-700 dark:text-blue-400 text-sm">
                {t(
                  "servicePageActivation.facebookCatalogue.infoBox.description"
                )}
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* domain */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-[#9e68ba] dark:text-[#b47ed6]">
              {t("servicePageActivation.facebookCatalogue.form.domain.label")}
            </label>
            <input
              type="text"
              className="w-full p-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg bg-white dark:!bg-[#181919] text-gray-900 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-200"
              placeholder={t(
                "servicePageActivation.facebookCatalogue.form.domain.placeholder"
              )}
              value={`${account.store}api/facebook-feed`}
              readOnly
            />
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {t("servicePageActivation.facebookCatalogue.form.domain.hint")}
            </p>
          </div>

          {/* Access Token */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-[#9e68ba] dark:text-[#b47ed6]">
              {t("servicePageActivation.facebookCatalogue.form.username.label")}
            </label>
            <input
              type="text"
              className="w-full p-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg bg-white dark:!bg-[#181919] text-gray-900 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-200"
              placeholder={t(
                "servicePageActivation.facebookCatalogue.form.username.placeholder"
              )}
              value={data.facebookCatalogUsername}
              onChange={(e) =>
                setData({ ...data, facebookCatalogUsername: e.target.value })
              }
            />
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {t("servicePageActivation.facebookCatalogue.form.username.hint")}
            </p>
          </div>

          {/* Password */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-[#9e68ba] dark:text-[#b47ed6]">
              {t("servicePageActivation.facebookCatalogue.form.password.label")}
            </label>
            <input
              className="w-full p-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg bg-white dark:!bg-[#181919] text-gray-900 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-200"
              placeholder={t(
                "servicePageActivation.facebookCatalogue.form.password.placeholder"
              )}
              value={data.facebookCatalogPassword}
              type="password"
              onChange={(e) =>
                setData({ ...data, facebookCatalogPassword: e.target.value })
              }
            />
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {t("servicePageActivation.facebookCatalogue.form.password.hint")}
            </p>
          </div>

          {/* Benefits Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
            {facebookBenefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white dark:!bg-[#181919] rounded-lg p-4 border border-gray-200 dark:!border-[#3c3a3d] shadow-sm"
              >
                <div className="flex items-center mb-2">
                  {benefit.icon}
                  <h5 className="font-medium text-gray-800 dark:text-gray-200 mr-2 text-sm">
                    {benefit.title}
                  </h5>
                </div>
                <p className="text-xs text-gray-600 dark:text-gray-400">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>

          {/* Buttons */}
          <div className="flex justify-between mt-8">
            <button
              type="button"
              onClick={handleDisable}
              disabled={
                loading ||
                (!data.facebookCatalogUsername && !data.facebookCatalogPassword)
              }
              className={`px-6 py-3 bg-gray-200 dark:!bg-[#3c3a3d] hover:bg-gray-300 dark:hover:bg-[#444143] text-gray-800 dark:text-gray-300 rounded-lg transition-colors flex items-center ${
                loading ||
                (!data.facebookCatalogUsername && !data.facebookCatalogPassword)
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              <X className="ml-2" size={18} />
              {t(
                "servicePageActivation.facebookCatalogue.form.buttons.disable"
              )}
            </button>

            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-3 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors flex items-center ${
                loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t(
                    "servicePageActivation.facebookCatalogue.form.buttons.loading"
                  )}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t(
                    "servicePageActivation.facebookCatalogue.form.buttons.submit"
                  )}
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  ) : (
    <div className="min-h-[400px] h-fit p-6 flex items-center justify-center dark:bg-[#141414]">
      <div className="dark:bg-[#181919]  bg-[#fcf6ff]  border border-[#3c3a3d] dark:!border-[#3c3a3d] rounded-xl shadow-sm p-6 text-center max-w-md">
        <div className="mb-4 flex justify-center">
          <div className="w-20 h-20 bg-red-900/20 rounded-full flex items-center justify-center">
            <Lock size={36} className="text-red-500" />
          </div>
        </div>
        <h3 className="text-xl font-bold text-red-400 mb-3">
          {t("servicePageActivation.facebookCatalogue.locked.title")}
        </h3>
        <p className="text-gray-300 text-[#141414]">
          {t("servicePageActivation.facebookCatalogue.locked.description")}
        </p>
        <a
          href="/plan"
          className="inline-block mt-6 px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
        >
          {t("servicePageActivation.facebookCatalogue.locked.button")}
        </a>
      </div>
    </div>
  );
}
